"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.User = void 0;
exports.changeDate = changeDate;
exports.clsNames = exports.clsDebounce = void 0;
exports.date = date;
exports.dateLocale = void 0;
exports.dbdate = dbdate;
exports.dbmonth = dbmonth;
exports.diffDate = void 0;
exports.endOfDate = endOfDate;
exports.setDateLocale = exports.sameDate = exports.round = exports.rand = exports.qsset = exports.qsget = exports.option = exports.num = exports.locale = exports.isValidDate = exports.isFunction = exports.isEmptyValue = exports.isEmpty = exports.fromNow = void 0;
exports.startOfDate = startOfDate;
exports.uid = exports.trim = exports.todate = exports.testValue = exports.testLabel = exports.test = exports.symb = exports.stateColor = void 0;
var _numeral = _interopRequireDefault(require("numeral"));
var _dateFns = require("date-fns");
var _locale = require("date-fns/locale");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var locale = 'th';

// ----- Util
exports.locale = locale;
var clsDebounce = function clsDebounce(func, wait) {
  var timeout;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    // @ts-ignore
    var context = this;
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      func.apply(context, args);
    }, wait);
  };
};
exports.clsDebounce = clsDebounce;
var clsNames = function clsNames() {
  for (var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    classes[_key2] = arguments[_key2];
  }
  return classes.filter(Boolean).join(' ');
};
exports.clsNames = clsNames;
var stateColor = function stateColor(state) {
  if (state === 'primary') return 'blue';
  if (state === 'secondary') return 'grey-blue';
  if (state === 'error') return 'red';
  if (state === 'warning') return 'orange';
  if (state === 'success') return 'green';
  if (state === 'info') return 'sky';
  return state;
};
exports.stateColor = stateColor;
var test = function test() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  return args.find(function (d) {
    return d !== undefined && d !== null;
  });
};
exports.test = test;
var testValue = function testValue(o) {
  return test(o.value, o.id, o);
};
exports.testValue = testValue;
var testLabel = function testLabel(o) {
  return test(o.label, o.text, o.name, o);
};
exports.testLabel = testLabel;
var option = function option(o, renderText) {
  return {
    value: testValue(o),
    label: renderText !== undefined && typeof renderText === 'function' ? renderText(o) : testLabel(o),
    labelText: testLabel(o)
  };
};
exports.option = option;
var symb = function symb(pack, file, mode) {
  return 'https://files.un-no.net/static/symb/' + pack + (mode ? '_' + mode : '') + '/' + file + '.svg';
};

// ----- Date
exports.symb = symb;
var _fdate = function _fdate(date, format) {
  return (0, _dateFns.format)(date, format, {
    locale: dateLocale()
  });
};
var setDateLocale = function setDateLocale(lang) {
  exports.locale = locale = lang;
  return locale;
};
exports.setDateLocale = setDateLocale;
var dateLocale = function dateLocale() {
  if (locale === 'th') return _locale.th;
  return _locale.enUS;
};
exports.dateLocale = dateLocale;
var isValidDate = function isValidDate(d) {
  return (0, _dateFns.isDate)(d) && (0, _dateFns.isValid)(d);
};
exports.isValidDate = isValidDate;
function date(d, format, def) {
  if (!format) format = 'S';
  if (!(d instanceof Date) && !isEmpty(d)) d = todate(d);
  if (!(0, _dateFns.isDate)(d) || !(0, _dateFns.isValid)(d)) {
    return def === undefined ? '' : def;
  }
  // format
  // L = D MMMM YYYY
  // M = D MMM YYYY
  // S = D MMM YY

  // P = DD/MM/YYYY
  // Pt = DD/MM/YYYY

  // D = YYYY-MM-DD
  // DT = YYYY-MM-DD HH:mm:ss

  var ext = '';
  if (format.length <= 2) {
    if (format.length === 2) {
      var t = format[1];
      if (t === 'T') {
        ext = _fdate(d, ' HH:mm:ss');
      } else if (t === 't') {
        ext = _fdate(d, ' HH:mm');
      }
    }
    var fixFormat = format[0];
    if (locale === 'th') {
      var year = d.getFullYear() + 543;
      if (fixFormat === 'L') return "".concat(_fdate(d, 'EEEE d MMMM'), " ").concat(year).concat(ext ? ' เวลา' + ext : '');
      if (fixFormat === 'M') return "".concat(_fdate(d, 'd MMMM'), " ").concat(year).concat(ext ? ' ,' + ext : '');
      if (fixFormat === 'S') return "".concat(_fdate(d, 'd MMM'), " ").concat(year.toString().substr(2)).concat(ext ? ' ,' + ext : '');
      if (fixFormat === 'P') return "".concat(_fdate(d, 'dd/MM/')).concat(year).concat(ext);
      if (fixFormat === 'Y') return year;
      if (fixFormat === 'Z') return "".concat(_fdate(d, 'MMMM'), " ").concat(year);
    }
    if (fixFormat === 'T') return _fdate(d, 'HH:mm:ss');
    if (fixFormat === 't') return _fdate(d, 'HH:mm');
    if (fixFormat === 'D') return _fdate(d, "yyyy-MM-dd".concat(ext));
    if (fixFormat === 'P') return _fdate(d, "dd/MM/yyyy".concat(ext));
    if (fixFormat === 'S') return _fdate(d, "d MMM yy".concat(ext));
    if (fixFormat === 'M') return _fdate(d, "d MMM yyyy".concat(ext ? ' ,' + ext : ''));
    if (fixFormat === 'L') return _fdate(d, "d MMMM yyyy".concat(ext ? ' ,' + ext : ''));
    if (fixFormat === 'Z') return _fdate(d, 'MMMM yyyy');
  }
  return _fdate(d, format);
}
function dbdate(d) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (Array.isArray(d) && d.length >= 2) return [dbdate(d[0], time), dbdate(d[1], time)].filter(Boolean).join('_');
  if (!!time) return date(d, 'DT');
  return date(d, 'D');
}
function dbmonth(d) {
  if (Array.isArray(d) && d.length >= 2) return [date(d[0], 'yyyy-MM'), date(d[1], 'yyyy-MM')].filter(Boolean).join('_');
  return date(d, 'yyyy-MM');
}
var _todate = function _todate(d) {
  if (typeof d === 'string') return (0, _dateFns.parseISO)(d);
  if (typeof d === 'number') return (0, _dateFns.fromUnixTime)(d > 100000000000 ? Math.floor(d / 1000) : d);
  return d;
};
var todate = function todate(d, def) {
  var df = _todate(d);
  if (isValidDate(df)) return df;
  if (df === undefined) return new Date();
  return def === undefined ? null : def;
};
exports.todate = todate;
var sameDate = function sameDate(d1, d2, a) {
  if (!(d1 instanceof Date)) d1 = todate(d1);
  if (!(d2 instanceof Date)) d2 = todate(d2);
  if (a === 'y') return (0, _dateFns.isSameYear)(d1, d2);
  if (a === 'm') return (0, _dateFns.isSameMonth)(d1, d2);
  if (a === 'w') return (0, _dateFns.isSameWeek)(d1, d2);
  return (0, _dateFns.isSameDay)(d1, d2);
};
exports.sameDate = sameDate;
function changeDate(d, interval, unit) {
  if (!(d instanceof Date)) d = todate(d);
  if (d > 0) {
    if (_typeof(interval) === 'object') return (0, _dateFns.add)(d, interval);
    if (unit === 'y') return (0, _dateFns.addYears)(d, interval);
    if (unit === 'm') return (0, _dateFns.addMonths)(d, interval);
    if (unit === 'w') return (0, _dateFns.addWeeks)(d, interval);
    if (unit === 'd') return (0, _dateFns.addDays)(d, interval);
    if (unit === 'h') return (0, _dateFns.addHours)(d, interval);
    if (unit === 'i') return (0, _dateFns.addMinutes)(d, interval);
    if (unit === 's') return (0, _dateFns.addSeconds)(d, interval);
  } else if (d < 0) {
    if (_typeof(interval) === 'object') return (0, _dateFns.sub)(d, interval);
    if (unit === 'y') return (0, _dateFns.subYears)(d, interval);
    if (unit === 'm') return (0, _dateFns.subMonths)(d, interval);
    if (unit === 'w') return (0, _dateFns.subWeeks)(d, interval);
    if (unit === 'd') return (0, _dateFns.subDays)(d, interval);
    if (unit === 'h') return (0, _dateFns.subHours)(d, interval);
    if (unit === 'i') return (0, _dateFns.subMinutes)(d, interval);
    if (unit === 's') return (0, _dateFns.subSeconds)(d, interval);
  }
  return d;
}
function startOfDate(d, unit) {
  if (!(d instanceof Date)) d = todate(d);
  if (unit === 'y') return (0, _dateFns.startOfYear)(d);
  if (unit === 'm') return (0, _dateFns.startOfMonth)(d);
  if (unit === 'w') return (0, _dateFns.startOfWeek)(d);
  if (unit === 'd') return (0, _dateFns.startOfDay)(d);
  if (unit === 'h') return (0, _dateFns.startOfHour)(d);
  if (unit === 'i') return (0, _dateFns.startOfMinute)(d);
  if (unit === 's') return (0, _dateFns.startOfSecond)(d);
  return d;
}
function endOfDate(d, unit) {
  if (!(d instanceof Date)) d = todate(d);
  if (unit === 'y') return (0, _dateFns.endOfYear)(d);
  if (unit === 'm') return (0, _dateFns.endOfMonth)(d);
  if (unit === 'w') return (0, _dateFns.endOfWeek)(d);
  if (unit === 'd') return (0, _dateFns.endOfDay)(d);
  if (unit === 'h') return (0, _dateFns.endOfHour)(d);
  if (unit === 'i') return (0, _dateFns.endOfMinute)(d);
  if (unit === 's') return (0, _dateFns.endOfSecond)(d);
  return d;
}
var diffDate = function diffDate(d1, d2, a) {
  if (!d2) d2 = new Date();
  if (!(d1 instanceof Date)) d1 = todate(d1);
  if (!(d2 instanceof Date)) d2 = todate(d2);
  if (a === 'y') return (0, _dateFns.differenceInYears)(d2, d1);
  if (a === 'm') return (0, _dateFns.differenceInMonths)(d2, d1);
  if (a === 'w') return (0, _dateFns.differenceInWeeks)(d2, d1);
  if (a === 'h') return (0, _dateFns.differenceInHours)(d2, d1);
  if (a === 'i') return (0, _dateFns.differenceInMinutes)(d2, d1);
  if (a === 's') return (0, _dateFns.differenceInSeconds)(d2, d1);
  return (0, _dateFns.differenceInDays)(d2, d1);
};
exports.diffDate = diffDate;
var fromNow = function fromNow(d) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var def = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (typeof d === 'string') d = todate(d);
  return isValidDate(d) ? (0, _dateFns.formatDistance)(todate(d), base || new Date(), {
    includeSeconds: true,
    locale: _locale.th
  }) : def;
};

// ----- User & Hook
exports.fromNow = fromNow;
var User = /*#__PURE__*/function () {
  function User(props) {
    _classCallCheck(this, User);
    _defineProperty(this, "id", 0);
    _defineProperty(this, "name", '');
    _defineProperty(this, "roles", []);
    if (props) for (var k in props) if (props.hasOwnProperty(k))
      // @ts-ignore
      this[k] = props[k];
  }
  _createClass(User, [{
    key: "allow",
    value: function allow(role) {
      return this.roles && this.roles.indexOf(role) >= 0;
    }
  }, {
    key: "update",
    value: function update(updates) {
      if (updates) for (var k in updates) if (updates.hasOwnProperty(k))
        // @ts-ignore
        this[k] = updates[k];
      return this;
    }
  }, {
    key: "admin",
    get: function get() {
      return this.allow('__admin');
    }
  }]);
  return User;
}(); // -----
exports.User = User;
var lastId = 0;
var uid = function uid() {
  return lastId++;
};
exports.uid = uid;
var num = function num(number, format) {
  var n = (0, _numeral.default)(number);
  if (format !== undefined) {
    if (typeof format === 'number') {
      return n.format(format > 0 ? '0,0.' + '0'.repeat(format) : '0,0');
    } else if (typeof format === 'string') {
      return n.format(format);
    }
  }
  return n.value() || 0;
};
exports.num = num;
var round = function round(number, per) {
  number = num(number);
  if (per > 0) return Math.round((number + Number.EPSILON) * Math.pow(10, per)) / Math.pow(10, per);
  return Math.round(number);
};
exports.round = round;
var rand = function rand(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
exports.rand = rand;
var trim = function trim(text, char) {
  if (!char) return text.trim();
  if (char === ']') char = '\\]';
  if (char === '\\') char = '\\\\';
  return text.replace(new RegExp('^[' + char + ']+|[' + char + ']+$', 'g'), '');
};
exports.trim = trim;
var isEmpty = function isEmpty(data) {
  if (data === undefined || data === null) return true;
  var type = _typeof(data);
  if (type === 'number' && data === 0) return true;
  if (type === 'string' && trim(data) === '') return true;
  if (type === 'object') {
    if (data instanceof Date) return isNaN(data.getTime());
    if (Array.isArray(data)) return data.length <= 0;
    if (Object.keys(data).length === 0) return true;
  }
  return false;
};
exports.isEmpty = isEmpty;
var isEmptyValue = function isEmptyValue(data) {
  if (data === undefined || data === null) return true;
  var type = _typeof(data);
  if (type === 'string' && trim(data) === '') return true;
  return false;
};
exports.isEmptyValue = isEmptyValue;
var isFunction = function isFunction(data) {
  if (data === undefined || data === null) return false;
  return typeof data === 'function';
};

// ----- QS
exports.isFunction = isFunction;
function qsParse(queryString) {
  var query = {};
  var pairs = (queryString[0] === '?' ? queryString.substring(1) : queryString).split('&');
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split('=');
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  }
  return query;
}
function qsStringify(obj) {
  var str = [];
  for (var p in obj) if (obj.hasOwnProperty(p) && obj[p] !== undefined && obj[p] !== null) str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
  return str.join('&');
}
var qsset = function qsset(params) {
  var ret = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var output = qsStringify(params);
  if (window && window.history && !ret) window.history.replaceState(null, '', window.location.pathname + '?' + output);
  return output;
};
exports.qsset = qsset;
var qsget = function qsget() {
  var def = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (window && window.location && window.location.search) {
    var search = window.location.search;
    var g = qsParse(search);
    if (!!g) {
      Object.keys(g).forEach(function (k) {
        if (def[k] !== undefined) {
          if (typeof def[k] === 'number') {
            g[k] = num(g[k]);
          }
        }
      });
      return _objectSpread(_objectSpread({}, def), g);
    }
  }
  return def;
};
exports.qsget = qsget;